//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
const ObjectFunc = require('@/tbs/util/ObjectFunc')
const FlowProcessor = require('@/tbs/util/FlowProcessor')
const DataConvertor = require('@/tbs/core/DataConvertor')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_PlayerMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_PlayerMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_PlayerMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    /**
     * @api
     * Handle the creation complete condition triggered by 
     * the scene instance.
     */
    handleCreationComplete: function() {
        // console.log('handleCreationComplete')
        const teamId = this._bridge.getRouteQuery('teamId')
        const matchGroupId = this._bridge.getRouteQuery('matchGroupId')
        if (this._bridge.isCreate()) {
            this.target().player.teamId = teamId
            this.target().player.matchGroupId = matchGroupId
            
        }
        else {
            if (this._bridge.isBatch()) {
                this.target().teamId = teamId
                this.target().matchGroupId = matchGroupId
                this.target().appendEmptyPlayer(true)
            }
            else {
                this.creationComplete()
            }
        }
    },
    handleRemoveService: function() {
        this._bridge.goToScene('OrgManageTeam', {id: this._bridge.getRouteQuery('teamId')}, {matchId: this._bridge.getRouteQuery('matchId'), matchGroupId: this._bridge.getRouteQuery('matchGroupId')})
    },
    handleDataLoaded: function(e) {
        console.log('handleDataLoaded', e)
        if (this._bridge.isBatch()) {
            // save the first return data
            this._prevSubmitData = ObjectFunc.cloneObject(this.target().playerList)
            // append the new input player item and scroll to the bottom
            this.appendEmptyPlayer(this._prevSubmitData.length === 0)
        }
        this.target().player.matchGroupId = this._bridge.getRouteQuery('matchGroupId')
        this.target().player.matchId = this._bridge.getRouteQuery('matchId')
    },
    handleCreateService: function(e) {
        console.log('handleCreateService', e.data.payload.data.id)
        const query = this._bridge.getRouteQuery()
        if (query.from) {
            this._bridge.goToScene(
                query.from, 
                {gameId: query.gameId},
                ObjectFunc.mergeObject({
                    teamId: query.teamId,
                    playerId: e.data.payload.data.id
                }, ObjectFunc.extractProperties(query, ['homeTeamId', 'awayTeamId', 'homeTeamName', 'awayTeamName', 'matchGroupId'])),
                true)
        }
        else {
            this._bridge.back()
        }
    },
    doSubmitBatchData: function(target, data) {
        console.log('doSubmitBatchData', target, data)
        const self = this
        // compare the submit data
        let actionList = []
        self._prevSubmitData = self._prevSubmitData || []
        const prevSubmitData = self._prevSubmitData
        // scan the data to find out the action items
        for (let i = 0; i < data.length; i++) {
            let curItem = data[i]
            if (curItem.id == null) {
                if (curItem.num && curItem.name) {
                    actionList.push({type: 'create', data: {seq: i, num: curItem.num, name: curItem.name, teamId: curItem.teamId, matchGroupId: curItem.matchGroupId}})
                } 
            }
            else {
                if (curItem.num == '' && curItem.name == '') {
                    actionList.push({type: 'remove', data: {seq: i, id: curItem.id}})
                }
                else if (curItem.num && curItem.name) {
                    for (let j = 0; j < prevSubmitData.length; j++) {
                        let prevItem = prevSubmitData[j]
                        if (curItem.id == prevItem.id) {
                            // console.log('compare the cur item and prev item', curItem, prevItem)
                            if (curItem.num != prevItem.num || curItem.name != prevItem.name) {
                                actionList.push({type: 'update', data: {seq: i, id: curItem.id, num: curItem.num, name: curItem.name}})
                            }
                        }
                    }
                }
            }
        }
        if (actionList.length == 0) {
            return
        }
        console.log('actionList', actionList)
        const fp = new FlowProcessor
        const ctx = {fp: fp}
        fp.regRules('PLAYER_BATCH_SERVICE', {callback: function() {
            console.log('PLAYER_BATCH_SERVICE end')
            self._prevSubmitData = data
            // history back
            self._bridge.back()
        }})
        for (let i = 0; i < actionList.length; i++) {
            let action = actionList[i]
            if (action.type == 'create') {
                fp.regFunc('flowCreatePlayer', [ctx, action], self)
            }
            else if (action.type == 'remove') {
                fp.regFunc('flowRemovePlayer', [ctx, action], self)
            }
            else if (action.type == 'update') {
                fp.regFunc('flowUpdatePlayer', [ctx, action], self)
            }
        }
        console.log('PLAYER_BATCH_SERVICE start')
        fp.launch()
    },
    flowCreatePlayer: function(ctx, action) {
        console.log('flowCreatePlayer', action)
        const self = this
        const convertor = self.convertor()
        const source = convertor.view.create
        const wrapper = DataConvertor.wrapper(convertor)
        const postBody = DataConvertor.transform(convertor, action.data, 'create')
        const service = 'create' + ObjectFunc.capitalizeFirstLetter(wrapper)
        self._bridge.addResourceListener(service, function(e) {
            self._bridge.removeResourceListener(service, e.handler)
            console.log('create.data', service, e.data)
            if (self.target().isEdit) {
                // update the id prop for the create result
                self.target().playerList[action.data.seq].id = e.data.payload.data.id
            }
            ctx.fp.launch()
        })
        self._bridge.callResourceInstance(service, {
            baseUrl: source.baseUrl,
            apiPrefix: source.apiPrefix,
            apiSuffix: source.apiSuffix,
            serviceName: source.service,
            method: 'POST',
            data: postBody
        })
    },
    flowUpdatePlayer: function(ctx, action) {
        console.log('flowUpdatePlayer', action)
        const self = this
        const convertor = self.convertor()
        const wrapper = DataConvertor.wrapper(convertor)
        const source = convertor.view.update
        const postBody = DataConvertor.transform(convertor, action.data, 'update')
        const service = 'update' + ObjectFunc.capitalizeFirstLetter(wrapper)
        self._bridge.addResourceListener(service, function(e) {
            self._bridge.removeResourceListener(service, e.handler)
            console.log('update.data', service, e.data)
            // do nothing for the update result
            ctx.fp.launch()
        })
        self._bridge.callResourceInstance(service, {
            baseUrl: source.baseUrl,
            apiPrefix: source.apiPrefix,
            apiSuffix: source.apiSuffix,
            serviceName: source.service,
            method: 'POST',
            data: postBody
        })
    },
    flowRemovePlayer: function(ctx, action) {
        console.log('flowRemovePlayer', action)
        const self = this
        const convertor = self.convertor()
        const wrapper = DataConvertor.wrapper(convertor)
        const source = convertor.view.remove
        const postBody = DataConvertor.transform(convertor, action.data, 'remove')
        const service = 'remove' + ObjectFunc.capitalizeFirstLetter(wrapper)
        self._bridge.addResourceListener(service, function(e) {
            self._bridge.removeResourceListener(service, e.handler)
            console.log('remove.data', service, e.data)
            if (self.target().isEdit) {
                // empty the id prop for the remove result
                self.target().playerList[action.data.seq].id = null
            }
            ctx.fp.launch()
        })
        self._bridge.callResourceInstance(service, {
            baseUrl: source.baseUrl,
            apiPrefix: source.apiPrefix,
            apiSuffix: source.apiSuffix,
            serviceName: source.service,
            method: 'POST',
            data: postBody
        })
    }
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_PlayerMediator, BaseMediator);

module.exports = tbs_controller_PlayerMediator